import type { Module } from "@scayla/api-client-fetch";
import { BuiltinModuleTag } from "@scayla/api-client-fetch";

type ModuleRef = Pick<Module, "id" | "builtinModule">;

/** The modules whose records a module's list shows: the module itself first, and for Dossiers also the emails. */
export function moduleScopeIds(module: ModuleRef, modules: readonly ModuleRef[]): string[] {
  if (module.builtinModule !== BuiltinModuleTag.DOCUMENTS) return [module.id];
  const emails = modules.find((candidate) => candidate.builtinModule === BuiltinModuleTag.EMAILS);
  return emails ? [module.id, emails.id] : [module.id];
}
